import angular from 'angular'
import declarationCreate from './declarationCreate'
import smallScaleTaskTrace from './smallScaleTaskTrace'
import smallScaleReportQuery from './smallScaleReportQuery'

export default angular
  .module('declaration.addValTaxSmallScale', [
    declarationCreate,
    smallScaleTaskTrace,
    smallScaleReportQuery,
  ])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      $stateProvider.state('declaration.addValTaxSmallScale', {
        abstract: true,
        url: '/addValTaxSmallScale',
        template: '<div ui-view></div>',
        title: '增值税申报及附加(小规模)',
      })
    },
  ]).name



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxSmallScale/index.js